<template>
    <div>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="55%"></b-skeleton>
        <b-skeleton width="100%"></b-skeleton>
        <b-skeleton width="50%"></b-skeleton>
        <b-skeleton width="65%"></b-skeleton>
        <b-skeleton width="85%"></b-skeleton>
        <b-skeleton width="100%"></b-skeleton>
        <b-skeleton width="70%"></b-skeleton>
        <b-skeleton width="50%"></b-skeleton>
        <b-skeleton width="100%"></b-skeleton>
        <b-skeleton width="65%"></b-skeleton>
    </div>
</template>

<script>
export default {
    name: 'CardSkeleton',
};
</script>
